const pageHeader = document.querySelector(`.page-header`)
const mainNav = pageHeader.querySelector(`.main-nav--dropdown`)
const burger = mainNav.querySelector(`.logo__burger`)
const mainNavList = pageHeader.querySelector(`.main-nav__list`)
const mobileNavElements = mainNav.querySelectorAll(`.main-nav__item--mobile`)
const signinElement = pageHeader.querySelector(`.signin`)

const openDropDown = () => {
  const signinClose = document.querySelector(`.logo__link--signin-open`)
  if (signinClose) {
    signinClose.click()
  }
  burger.classList.add(`logo__burger--close`)
  burger.removeEventListener(`click`, openDropDown)
  burger.addEventListener(`click`, closeDropDown)
  mainNav.classList.add(`main-nav--dropdown-open`)
  mainNavList.classList.add(`main-nav__list--open`)
  const banner = pageHeader.querySelector(`.banner`)
  if (banner) {
    mainNav.style.height = 'calc(100vh - 30px)'
  } else {
    mainNav.style.height = '100vh'
  }
  mobileNavElements.forEach((element) => {
    element.style.display = `flex`
  })
  const navOpen = document.querySelector(`.logo__link--signin-open`)
  if (navOpen) {
    signinElement.classList.remove('signin--visible')
  }
}

const closeDropDown = () => {
  burger.classList.remove(`logo__burger--close`)
  burger.removeEventListener(`click`, closeDropDown)
  burger.addEventListener(`click`, openDropDown)
  mainNav.classList.remove(`main-nav--dropdown-open`)
  mainNavList.classList.remove(`main-nav__list--open`)
  mainNav.style.height = '80px'
  mobileNavElements.forEach((element) => {
    element.style.display = `none`
  })
  const navOpen = document.querySelector(`.logo__link--signin-open`)
  if (navOpen) {
    signinElement.classList.add('signin--visible')
  }
}

if (burger) {
  burger.addEventListener(`click`, openDropDown)
}
